import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID, TransferState } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  AuthService,
  GoogleTagService,
  SOCIAL_AUTH_ERROR,
  SOCIAL_AUTH_TOKEN,
  ToastService,
} from '@gb-webapp/gb-app';
import { firstValueFrom } from 'rxjs';

export const initAuthGuard: CanActivateFn = async () => {
  const platform = inject(PLATFORM_ID);
  const authService = inject(AuthService);
  const transferState = inject(TransferState);
  const gtmService = inject(GoogleTagService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  if (!isPlatformServer(platform)) {
    const token = transferState.get(SOCIAL_AUTH_TOKEN, null);
    const socialAuthError = transferState.get(SOCIAL_AUTH_ERROR, null);

    if (token) {
      gtmService.pushEvent(token?.firstSigninAttempt ? 'social_sign_up' : 'social_sign_in', {
        eventType: token?.firstSigninAttempt ? 'sign_up' : 'sign_in',
        pageUrl: router.url,
      });
    }

    // Show error toast if social auth failed
    if (socialAuthError) {
      const toast = await firstValueFrom(toastService.openErrorToast(socialAuthError));
      toast.present();
      // Clear the error from transfer state so it doesn't show again on navigation
      transferState.remove(SOCIAL_AUTH_ERROR);
    }

    authService.checkSocialUserTransferState();
    authService.initAuthSate();
  }

  return true;
};
